<div class="confirm-dialog-container">
  <p class="text-center">
    <i class="icon-warning_white warning-icon" aria-hidden="true"></i>
  </p>
  <p>Are you sure you want to delete this file?</p>
</div>
<div class="confirm-dialog-footer">
  <button data-cy="cancel-deletion" mat-flat-button class="mat-secondary" (click)="confirmAction(false)">Cancel</button>
  <button data-cy="confirm-deletion" mat-flat-button class="mat-primary ml-4" (click)="confirmAction(true)">Yes</button>
</div>
